import { Injectable, signal } from '@angular/core';
import { RegistrationData } from '@app/core/types/registration-data.types';
import { StorageVariables } from '@app/shared/enums/storage.enums';

@Injectable({ providedIn: 'root' })
export class RegistrationDataService {
  readonly registrationData = signal<RegistrationData>(this.readRegistrationData());

  /** Persisted so the prefill survives the app being killed mid-registration. */
  setRegistrationData(data: RegistrationData): void {
    this.registrationData.set(data);
    localStorage.setItem(StorageVariables.RegistrationData, JSON.stringify(data));
  }

  clearRegistrationData(): void {
    this.registrationData.set({});
    localStorage.removeItem(StorageVariables.RegistrationData);
  }

  private readRegistrationData(): RegistrationData {
    try {
      return JSON.parse(localStorage.getItem(StorageVariables.RegistrationData)) ?? {};
    } catch {
      return {};
    }
  }
}
